<div class="flex flex-col items-stretch mb-4">
  <csl-materials
    class="mb-4"
    [disabled]="disabled"
    [showMaterialsPrice]="cuttingSettings.estimateSettings.showMaterialsPrice"
    [currencySymbol]="currencySymbol"
    [showEdge]="showEdge"
    [showQuantityInStock]="cuttingSettings.showQuantityInStock">
  </csl-materials>

  <csl-sizes
    [disabled]="disabled"
    [panelsSettings]="cuttingSettings.panels"
    (onValid)="validPanelSize($event)"
    class="mb-0"></csl-sizes>

  <ng-content #actions></ng-content>
</div>

<mat-accordion>
  <mat-accordion #accordion="matAccordion">
    <mat-expansion-panel [ngClass]="{ hidden: !showFasteners }" [disabled]="!isMaterialSelected || !validPanelForm">
      <mat-expansion-panel-header data-testid="fastenerButton">
        <mat-panel-title class="flex flex-row justify-between gap-4">
          <div i18n>Присадка</div>
          <div *ngIf="!disabled && !isMaterialSelected" i18n class="mat-caption">Выберите материал</div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <mat-divider> </mat-divider>

      <csl-fasteners [disabled]="disabled"></csl-fasteners>

      <mat-divider> </mat-divider>
    </mat-expansion-panel>

    <mat-expansion-panel
      [ngClass]="{ hidden: !showAngleProcessing }"
      [disabled]="!isMaterialSelected || !validPanelForm">
      <mat-expansion-panel-header data-testid="angleProcessingButton">
        <mat-panel-title class="flex flex-row justify-between gap-4">
          <div i18n>Обработка углов</div>
          <div *ngIf="!disabled && !isMaterialSelected" i18n class="mat-caption">Выберите материал</div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <csl-angles-processing
        [disabled]="disabled"
        [outlineEditorOptions]="cuttingSettings.outlineEditorOptions"
        [angleProcessingAvailability]="componentsAvailability?.angleProcessingAvailability"></csl-angles-processing>
    </mat-expansion-panel>

    <mat-expansion-panel [ngClass]="{ hidden: !showSlots }" [disabled]="!isMaterialSelected || !validPanelForm">
      <mat-expansion-panel-header data-testid="slotsButton">
        <mat-panel-title class="flex flex-row justify-between gap-4">
          <div i18n>Пазы</div>
          <div *ngIf="!disabled && !isMaterialSelected" i18n class="mat-caption">Выберите материал</div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <csl-slots [disabled]="disabled"></csl-slots>
    </mat-expansion-panel>

    <mat-expansion-panel [ngClass]="{ hidden: !showMilling }" [disabled]="!isMaterialSelected || !validPanelForm">
      <mat-expansion-panel-header data-testid="millingButton">
        <mat-panel-title class="flex flex-row justify-between gap-4">
          <div i18n>Фрезеровка</div>
          <div *ngIf="!disabled && !isMaterialSelected" i18n class="mat-caption">Выберите материал</div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <csl-millings [userId]="userId" [disabled]="disabled"></csl-millings>
    </mat-expansion-panel>

    <mat-expansion-panel [ngClass]="{ hidden: !showHandles }" [disabled]="!isMaterialSelected || !validPanelForm">
      <mat-expansion-panel-header data-testid="handleButton">
        <mat-panel-title class="flex flex-row justify-between gap-4">
          <div i18n>Ручка</div>
          <div *ngIf="!disabled && !isMaterialSelected" i18n class="mat-caption">Выберите материал</div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <csl-handle [disabled]="disabled"></csl-handle>
    </mat-expansion-panel>
  </mat-accordion>
</mat-accordion>
